import React from 'react';
import { Flex, Text, Pane } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Validator } from '@leverege/validator';
import { GlobalState } from '@leverege/ui-redux';
import Loading from "../../../../../components/Loading.js";
import TRDialog from "./TRDialog.js";
import { activate } from "../../../../util/TheftRecovery.js";
import Detail from "./Detail.js";
import DetailArea from "./DetailArea.js";
import ImageUploader from "./ImageUploader.js"; // import S from './TheftRecovery.css'
import { ONE_HOUR_IN_MS } from "../../../../../constants/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovrGeneric.theftRecovery.EnableDialog');
const {
  t: tAssetName
} = I18N.ns('recovrGeneric.assetIndustryName');
export default class EnableDialog extends React.Component {
  constructor(props) {
    super(props);
    const authProfile = GlobalState.get().auth.profile;
    const {
      name,
      email,
      phone
    } = authProfile;
    this.state = {
      loading: false,
      errorActive: !(name && phone && email),
      contactErrors: {
        email: null,
        name: null,
        phone: null
      },
      name,
      phone,
      email,
      description: '',
      image: null
    };
  }
  onChange = ({
    data,
    value
  }) => {
    this.setState({
      [data]: value
    });
    if (this.isContactInfoData(data)) {
      this.validateContactInfo(data, value);
    }
  };
  isContactInfoData = eventData => {
    return eventData === 'email' || eventData === 'phone' || eventData === 'name';
  };
  onOkay = async () => {
    const {
      onClose,
      sharedProps: {
        item,
        actions
      }
    } = this.props;
    // const { companyId } = actions?.match?.params || {}
    const {
      errorActive,
      name,
      email,
      phone,
      description,
      image
    } = this.state;
    const assetId = item?.id;
    const contactInfo = {
      name,
      email,
      phone
    };
    const assetDetails = {
      description
    };
    if (!errorActive) {
      await activate({
        asset: item,
        assetId,
        onClose,
        onChange: this.onChange,
        actions,
        contactInfo,
        description,
        assetDetails,
        image
      });
    }
  };
  validateContactInfo = (data, value) => {
    const validatorMap = {
      email(email) {
        return {
          email: Validator.isEmail(email) ? null : t('invalidEmail')
        };
      },
      name(name) {
        return {
          name: Validator.required(name) ? null : t('invalidName')
        };
      },
      phone(phone) {
        return {
          phone: Validator.isPhone(phone) ? null : t('invalidPhone')
        };
      }
    };
    const error = validatorMap[data] ? validatorMap[data](value) : {
      data: null
    };
    const {
      contactErrors
    } = this.state;
    const newErrors = {
      ...contactErrors,
      ...error
    };
    this.setState({
      contactErrors: newErrors
    });
    if (error[data]) {
      this.setState({
        errorActive: true
      });
    } else if (Object.values(newErrors).filter(p => p !== null).length === 0) {
      this.setState({
        errorActive: false
      });
    }
  };
  getWarning() {
    const {
      sharedProps: {
        item
      }
    } = this.props;
    const locator = item?.data?.locator?.data;
    let text;
    if (locator?.lastHeartbeat < Date.now() - 3 * ONE_HOUR_IN_MS) {
      text = t('lastHeartbeatWarning');
    }
    if (locator?.batteryLevel < 20) {
      text = t('batteryLevelWarning');
    }
    if (text?.length) {
      return /*#__PURE__*/_jsx(Flex, {
        variant: "rowL",
        children: /*#__PURE__*/_jsx(Text, {
          variant: "theftRecoveryInfo",
          children: text
        })
      });
    }
    return null;
  }
  getLoadingScreen() {
    return /*#__PURE__*/_jsx(Loading, {
      message: "Activating Theft Recovery",
      loading: true
    });
  }
  render() {
    const {
      show,
      onClose
    } = this.props;
    const {
      loading,
      contactErrors,
      errorActive,
      name,
      phone,
      email,
      description,
      image
    } = this.state;
    const uiName = process.env.UI_NAME;
    const assetIndustryName = tAssetName(uiName, 'Asset');
    return /*#__PURE__*/_jsxs(TRDialog, {
      show: show,
      onOkay: this.onOkay,
      onClose: onClose,
      okayDisabled: loading || errorActive,
      title: "Activate Theft Recovery Mode?",
      okay: "Activate Theft Recovery",
      children: [/*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        style: {
          marginBottom: '16px'
        },
        children: [loading && this.getLoadingScreen(), this.getWarning(), /*#__PURE__*/_jsx(Pane, {
          children: /*#__PURE__*/_jsxs(Text, {
            children: [t('info', {
              assetIndustryName
            }), " ", /*#__PURE__*/_jsx("b", {
              children: t('lawInfo')
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        style: {
          marginBottom: '16px',
          gap: '0px'
        },
        children: [/*#__PURE__*/_jsx(Text, {
          style: {
            fontSize: '14px',
            fontWeight: 600
          },
          children: t('contact')
        }), /*#__PURE__*/_jsx(Text, {
          style: {
            fontSize: '14px'
          },
          children: t('reachOut')
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsx(Detail, {
          id: "name",
          label: t('contactName'),
          type: "column",
          value: name,
          hint: t('nameHint'),
          onChange: this.onChange,
          error: contactErrors.name
        }), /*#__PURE__*/_jsx(Detail, {
          id: "email",
          label: t('contactEmail'),
          type: "column",
          value: email,
          hint: t('emailHint'),
          onChange: this.onChange,
          error: contactErrors.email
        }), /*#__PURE__*/_jsx(Detail, {
          id: "phone",
          label: t('contactPhone'),
          type: "column",
          value: phone,
          hint: t('phoneHint'),
          onChange: this.onChange,
          error: contactErrors.phone
        }), /*#__PURE__*/_jsx(ImageUploader, {
          eventData: "image",
          label: t('assetImage', {
            assetIndustryName
          }),
          type: "column",
          value: image,
          onChange: this.onChange
        }), /*#__PURE__*/_jsx(DetailArea, {
          id: "description",
          label: t('assetDescription', {
            assetIndustryName
          }),
          type: "column",
          value: description,
          onChange: this.onChange
        })]
      })]
    });
  }
}